import { ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlexBox from '../../../../components/ui/flexbox/FlexBox';
import LoadingDots from '../../../../components/ui/loading/LoadingDots';

interface IInfiniteScrollWrapperProps {
  key?: string;
  children: ReactNode;
  dataLength: number;
  next: () => void;
  hasMore: boolean;
  scrollThreshold: number;
}

function InfiniteScrollWrapper({
  key,
  children,
  dataLength,
  next,
  hasMore,
  scrollThreshold
}: IInfiniteScrollWrapperProps) {
  return (
    <InfiniteScroll
      key={key}
      dataLength={dataLength}
      next={next}
      hasMore={hasMore}
      scrollThreshold={scrollThreshold}
      loader={
        <FlexBox $justifyContent="center" $alignItems="center">
          <LoadingDots />
        </FlexBox>
      }
    >
      {children}
    </InfiniteScroll>
  );
}

export default InfiniteScrollWrapper;
